module.exports = __webpack_public_path__ + "static/media/agnus-dei-p7.c2ab4868.jpg";